export default "__VITE_ASSET__CScGVO4c__"